import { nanoid } from 'nanoid';

export function getLongId(prefix?: string) {
  return prefix ? `${prefix}_${nanoid()}` : nanoid();
}
